<template>
  <div>
      <three-column-grid v-if="this.$mq.xl" :artworks="artworks">
        <template v-slot:default="{ artwork }">
          <artwork-card
            class="mb-30 lg:mb-56"
            :artwork="artwork"
            @update:artwork="sync(artwork, $event)">
          </artwork-card>
        </template>
      </three-column-grid>

      <two-column-grid v-else :artworks="artworks">
        <template v-slot:default="{ artwork }">
          <artwork-card
            class="mb-30 lg:mb-56"
            :artwork="artwork"
            @update:artwork="sync(artwork, $event)">
          </artwork-card>
        </template>
      </two-column-grid>
  </div>
</template>
<script>
import ThreeColumnGrid from "./GridLoader/ThreeColumnGrid.vue"
import TwoColumnGrid from "./GridLoader/TwoColumnGrid.vue"
import ArtworkCard from "./GridLoader/Cards/ArtworkCard.vue"

export default {

  components: {
    ThreeColumnGrid,
    TwoColumnGrid,
    ArtworkCard,
  },

  props: {
    artworks: { required: true, type: Array },
    event: { type: Object },
  },

  data () {
    return {
      loading: true,
    }
  },

  methods: {
    sync (target, source) {
      Object.assign(target, source)
    },
  },

}
</script>
